/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const splitInventoryRowDataSchema = z.object({
	quantity: z.number(),
	valueCents: z.number(),
	description: z.string().nullable(),
})

export type SplitInventoryRowDataSchema = z.infer<typeof splitInventoryRowDataSchema>
